(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-standalone"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initCarousel(wrapper) {
      var track = wrapper.querySelector('.carousel-standalone__track');
      var slides = Array.from(wrapper.querySelectorAll('.carousel-standalone__slide'));
      var dots = Array.from(wrapper.querySelectorAll('.carousel-standalone__dot'));
      var prevBtn = wrapper.querySelector('.carousel-standalone__arrow--prev');
      var nextBtn = wrapper.querySelector('.carousel-standalone__arrow--next');
      var total = slides.length;

      if (total <= 1) return;

      var current = 0;
      var autoplayTimer = null;
      var isPlaying = wrapper.dataset.autoplay === 'true';
      var autoplaySpeed = parseInt(wrapper.dataset.autoplaySpeed, 10) || 5000;
      var isDragging = false;
      var startX = 0;
      var dragDelta = 0;

      function goTo(index, instant) {
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;

        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        if (dots[current]) {
          dots[current].classList.remove('is-active');
          dots[current].setAttribute('aria-selected', 'false');
        }

        current = index;

        slides[current].classList.add('is-active');
        slides[current].setAttribute('aria-hidden', 'false');
        if (dots[current]) {
          dots[current].classList.add('is-active');
          dots[current].setAttribute('aria-selected', 'true');
        }

        var offset = current * -100;

        if (instant) {
          track.style.transition = 'none';
          track.style.transform = 'translateX(' + offset + '%)';
          track.offsetHeight; // force reflow
          track.style.transition = '';
        } else {
          track.style.transform = 'translateX(' + offset + '%)';
        }

        // Update tabindex on interactive children
        slides.forEach(function (slide, i) {
          var focusables = slide.querySelectorAll('a, button');
          focusables.forEach(function (el) {
            el.setAttribute('tabindex', i === current ? '0' : '-1');
          });
        });
      }

      function startAutoplay() {
        if (!isPlaying) return;
        stopAutoplay();
        autoplayTimer = setInterval(function () {
          goTo(current + 1);
        }, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function pauseOnInteraction() {
        stopAutoplay();
        // Resume after 8 seconds of inactivity
        setTimeout(startAutoplay, 8000);
      }

      // Arrows
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(current - 1);
          pauseOnInteraction();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(current + 1);
          pauseOnInteraction();
        });
      }

      // Dots
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.dotIndex, 10));
          pauseOnInteraction();
        });
      });

      // Keyboard navigation
      wrapper.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          goTo(current - 1);
          pauseOnInteraction();
        } else if (e.key === 'ArrowRight') {
          goTo(current + 1);
          pauseOnInteraction();
        }
      });

      // Touch / drag support
      var trackContainer = wrapper.querySelector('.carousel-standalone__track-container');

      trackContainer.addEventListener('pointerdown', function (e) {
        isDragging = true;
        startX = e.clientX;
        dragDelta = 0;
        track.style.transition = 'none';
        trackContainer.setPointerCapture(e.pointerId);
      });

      trackContainer.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        dragDelta = e.clientX - startX;
        var baseOffset = current * -100;
        var dragPercent = (dragDelta / trackContainer.offsetWidth) * 100;
        track.style.transform = 'translateX(calc(' + baseOffset + '% + ' + dragDelta + 'px))';
      });

      trackContainer.addEventListener('pointerup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = '';
        var threshold = trackContainer.offsetWidth * 0.15;
        if (dragDelta < -threshold) {
          goTo(current + 1);
        } else if (dragDelta > threshold) {
          goTo(current - 1);
        } else {
          goTo(current); // snap back
        }
        pauseOnInteraction();
      });

      trackContainer.addEventListener('pointercancel', function () {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = '';
        goTo(current);
      });

      // Prevent click events from firing during drag
      trackContainer.addEventListener('click', function (e) {
        if (Math.abs(dragDelta) > 5) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      // Pause autoplay on focus/hover
      wrapper.addEventListener('mouseenter', stopAutoplay);
      wrapper.addEventListener('mouseleave', startAutoplay);
      wrapper.addEventListener('focusin', stopAutoplay);
      wrapper.addEventListener('focusout', startAutoplay);

      // Init
      goTo(0, true);
      startAutoplay();
    }

    function init() {
      document.querySelectorAll('.carousel-standalone__wrapper').forEach(function (wrapper) {
        if (wrapper.dataset.carouselInit) return;
        wrapper.dataset.carouselInit = 'true';
        initCarousel(wrapper);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Shopify theme editor support
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        var wrapper = e.target.querySelector('.carousel-standalone__wrapper');
        if (wrapper) {
          delete wrapper.dataset.carouselInit;
          initCarousel(wrapper);
        }
      });

      document.addEventListener('shopify:block:select', function (e) {
        var wrapper = e.target.closest('.carousel-standalone__wrapper');
        if (!wrapper) return;
        var slide = e.target.closest('.carousel-standalone__slide');
        if (!slide) return;
        var index = parseInt(slide.dataset.slideIndex, 10);
        // trigger navigation to the selected slide
        var event = new CustomEvent('carousel:goto', { detail: { index: index } });
        wrapper.dispatchEvent(event);
      });

      document.querySelectorAll('.carousel-standalone__wrapper').forEach(function (wrapper) {
        wrapper.addEventListener('carousel:goto', function (e) {
          // find the carousel instance via a stored reference if needed
          // for simplicity, rebuild init if not already stored
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
